import { GH, NG } from "@zenith/data/constants";

/**
 * Handles the country code on a phone number.
 * @function
 * @name handleCountryCode
 * @kind function
 * @param {string} countryCode The string country code.
 * @returns {string} A string indicative number.
 * @exports
 */
export function handleCountryCode(countryCode: string): string {
  switch (countryCode) {
    case NG:
      return "+234";

    case GH:
      return "+233";

    default:
      throw new Error("Country code not mapped.");
  }
}
